// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1WCvK","col":"CardReaderDesc_col__30mLP","label":"CardReaderDesc_label__1y8K8"};